// fix/pwa-versi (2026-10-08): no imports, so Jest can test it.
// A running page compares the version it was built with to /version.json.

export const INTERVAL_CEK_MS = 5 * 60 * 1000;

export const versiSah = (v) => typeof v === "string" && /^[0-9a-f]{7,12}$/.test(v);

// true only when both versions are real commits and they differ
export function adaVersiBaru(lokal, server) {
  return versiSah(lokal) && versiSah(server) && lokal !== server;
}

// pages without forms (shop/station TV) load the new version at once;
// every other page waits for the next menu change (no typed input is lost)
// owner 2026-10-16: the layar produksi reloads itself, only in its quiet hours (sound must be
// switched on again after a reload), so the general banner/reload stays off there
export const diaturSendiri = (pathname) => (pathname || "").startsWith("/monitoring/layar") || (pathname || "") === "/monitoring/layar/uji";

export function muatLangsung(pathname) {
  return pathname === "/tv" || (pathname || "").startsWith("/tv/");
}
